import React, { Children, useEffect, useState } from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { Box, DialogActions, DialogContent, Grid } from '@mui/material';
import { ErrorDetails, styles } from './alert-context-helper';

interface ErrorDetailsDialogProps {
    errorDetails: string;
    handleOnClose: () => void;
}

export const ErrorDetailsDialog = ({
    errorDetails,
    handleOnClose,
}: ErrorDetailsDialogProps): React.JSX.Element => {
    const [parsedError, setParsedError] = useState<ErrorDetails>();
    const onDialogCloseButtonClick = (): void => {
        handleOnClose();
    };

    useEffect(() => {
        const parsedErrorDetails = JSON.parse(errorDetails);
        setParsedError(parsedErrorDetails);
    }, [errorDetails]);

    return (
        <Dialog
            open={true}
            closable={true}
            onClose={onDialogCloseButtonClick}
            sx={styles.dialog}
            title={parsedError?.message ?? ''}
        >
            <DialogContent>
                <Grid sx={styles.errorDetailsContainer}>
                    {Array.isArray(parsedError?.details)
                        ? Children.toArray(
                              parsedError?.details?.map((item) => {
                                  return <Box>{item}</Box>;
                              })
                          )
                        : parsedError?.details}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={onDialogCloseButtonClick}
                    color='primary'
                    variant='contained'
                    size='small'
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
